import { Button, Card, CardContent } from '@recipes/ui';
import { CircleHelp, ExternalLink } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { FeaturePageHeader, PageContainer } from '@/features/shared/page-header';
import { LegalLinks } from '@/features/legal/legal-links';

/** One file in the repository (docs/user-help.html), copied by the build. */
export const USER_HELP_URL = '/help.html';

/** On the profile, where the phone – without a sidebar – finds the help. */
export function HelpCard() {
  const { t } = useTranslation();
  return (
    <Card>
      <CardContent className="flex items-center gap-3 p-4">
        <CircleHelp className="size-5 shrink-0 text-muted-foreground" aria-hidden />
        <div className="min-w-0 flex-1">
          <p className="font-medium">{t('help.title')}</p>
          <p className="text-sm text-muted-foreground">{t('help.description')}</p>
        </div>
        <Button asChild variant="outline">
          <Link to="/help" data-testid="profile-help">
            {t('help.open')}
          </Link>
        </Button>
      </CardContent>
    </Card>
  );
}

/**
 * The help for everybody who uses the app – written once as plain HTML in the repository, shown
 * here as it is, so that it can be read without the app as well.
 */
export function HelpPage() {
  const { t } = useTranslation();
  return (
    <PageContainer className="max-w-4xl">
      <FeaturePageHeader
        title={t('help.title')}
        description={t('help.description')}
        actions={
          <Button asChild variant="outline">
            <a href={USER_HELP_URL} target="_blank" rel="noreferrer" data-testid="help-open">
              <ExternalLink aria-hidden /> {t('help.openTab')}
            </a>
          </Button>
        }
      />
      <iframe
        src={USER_HELP_URL}
        title={t('help.title')}
        className="h-[75vh] w-full rounded-lg border bg-card"
        data-testid="help-frame"
      />
      <LegalLinks className="mt-4" />
    </PageContainer>
  );
}
